

import { Component, Vue } from 'vue-property-decorator';
import SMSRepositoryInterface, { SmsTemplateInterface } from '@/services/SMS/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddSmsForm from '@/services/SMS/forms/AddSms';

@Component({
  inject: ['smsRepository'],
})
export default class AddSms extends Vue {

  public templatesList: SmsTemplateInterface[] = [];
  public selectedType = '';

  private senderName: string = '';
  private clientPhoneNumber: string = '';
  private message: string = '';

  private form: WPXFormValue<AddSmsForm> = new WPXFormValue(AddSmsForm);
  private readonly smsRepository: SMSRepositoryInterface;

  public async addSms() {
    await this.smsRepository.createSMS({
      senderName: this.senderName,
      clientPhoneNumber: this.clientPhoneNumber,
      message: this.message,
    });
  }
  public async loadTemplates() {
    this.templatesList = await this.smsRepository.loadTemplates()
  }

  public async selectTemplate(selectedType:string) {
    const template = await this.smsRepository.getTemplate(selectedType)
    this.senderName = template.senderName
    this.message = template.predefinedMessage
  }
}
